import React, { useEffect, useState } from "react";

import { ResultBar } from "@/components/ResultBar/ResultBar";

import { OptionEnum, OptionModeEnum, OptionTypeEnum } from "../index";
import { Text, TextWrapper, Wrapper } from "./styles";

export type TextOptionProps = {
  interactionId: string;
  slideId: string;
  optionId: string;
  mode: OptionModeEnum;
  type: OptionTypeEnum;
  isClickable: boolean;
  isSecret?: boolean;
  isMultipleChoice?: boolean;
  isFinished?: boolean;
  answer?: OptionEnum;
  percent?: number;
  votes?: number;
  onClick: Function;
  children?: React.ReactNode;
};
export type TextOptionState = {
  wasClicked: boolean;
  answerState: OptionEnum | undefined;
};

export const TextOption: React.FC<TextOptionProps> = (
  props: TextOptionProps
): React.ReactElement => {
  const {
    mode,
    type,
    percent,
    votes,
    answer,
    isSecret,
    isMultipleChoice,
    isFinished,
    isClickable,
    interactionId,
    slideId,
    optionId,
    onClick,
  } = props;
  const [localAnswer, setLocalAnswer] = useState<OptionEnum | undefined>(
    answer
  );
  const [wasClicked, setWasClicked] = useState<boolean>(false);

  useEffect(() => {
    // User clicked the wrong answer. Resolve correct answers.
    if (
      type === OptionTypeEnum.quiz &&
      answer === OptionEnum.correct &&
      !wasClicked
    ) {
      setTimeout(() => setLocalAnswer(answer), 800);
    } else {
      setLocalAnswer(answer);
    }
  }, [answer]);

  const handleClick = (): void => {
    if (!isClickable) {
      return;
    }

    if (type === OptionTypeEnum.quiz) {
      onClick({
        quizId: interactionId,
        slideId,
        optionId,
      });
    } else {
      onClick({ interactionId, slideId, optionId });
    }

    setWasClicked(true);
  };

  return (
    <Wrapper data-qa="answer:btn" onClick={handleClick} clickable={isClickable}>
      <TextWrapper
        type={type}
        answer={localAnswer}
        mode={mode}
        clickable={isClickable}
      >
        <Text>{props.children}</Text>
      </TextWrapper>
      <ResultBar
        mode={mode}
        type={type}
        percent={percent}
        votes={votes}
        answer={localAnswer}
        isSecret={isSecret}
        isMultipleChoice={isMultipleChoice}
        isFinished={isFinished}
      />
    </Wrapper>
  );
};
